import { scrollIfNeeded } from './helpers'

export default {
  onSelectByArrow (e) {
    e.preventDefault()

    if (this.disabled || this.readonly) return

    this.showMenu()
    if (this.arrowsIndex === null) {
      this.arrowsIndex = this.selectedItemIndex || -1
    }

    if (e.key === 'ArrowDown') {
      this.arrowsIndex++
    }
    if (e.key === 'ArrowUp') {
      this.arrowsIndex--
    }

    const end = this.itemsComputed.length - 1
    if (this.arrowsIndex < 0) {
      this.arrowsIndex = end
    }
    if (this.arrowsIndex > end) {
      this.arrowsIndex = 0
    }

    const itemByArrowsIndex = this.itemsComputed[this.arrowsIndex]

    if (this.arrowsDisableInstantSelection) {
      this.selectedItemByArrows = itemByArrowsIndex
    } else {
      this.setSearchData('')
      this.selectedItem = itemByArrowsIndex

      this.fireSelectEvent(this.selectedItem)
    }

    if (this.scrollToItemIfNeeded) {
      this.$nextTick(() => {
        const selectedElement = this.$refs.items[this.arrowsIndex]

        if (!selectedElement) return

        scrollIfNeeded(selectedElement, this.$refs['IZ-select__menu-items'])
      })
    }
  },
  onEnter (e) {
    if (this.hasMenu) {
      e.preventDefault()

      let needToResetSearch = false
      if (!this.arrowsIndex && !this.disableFirstItemSelectOnEnter) {
        const firstItem = this.itemsComputed[0]

        if (!firstItem) return

        this.fireSelectEvent(
          this.selectedItem = firstItem
        )
        needToResetSearch = true
      }
      if (this.arrowsDisableInstantSelection && this.selectedItemByArrows) {
        this.fireSelectEvent(
          this.selectedItem = this.selectedItemByArrows
        )
        needToResetSearch = true
      }

      if (needToResetSearch) this.setSearchData('')
    }

    this.hasMenu ? this.hideMenu() : this.showMenu()
  },
  onClick () {
    if (this.disabled || this.readonly) return

    this.setFocused()
    this.showMenu()
  },
  onClickSelectItem (item, i) {
    this.selectedItem = item
    this.setSearchData('')
    this.setInputFocused()
    this.hideMenu()
    this.fireSelectEvent(item)
    this.focused = false
  },
  onSearchKeyDown (e) {
    if (this.disabled || this.readonly) return

    if (['Enter', 'ArrowDown', 'ArrowUp', 'Tab'].includes(e.key)) return

    if (!e.target.value && e.key === 'Backspace') {
      this.selectedItem = null
      this.arrowsIndex = null
    }
    this.showMenu()
    this.$emit('keydown', e)
  },
  onSearchKeyUp (e) {
    if (this.disabled || this.readonly) return

    this.$emit('keyup', e)
  },
  onSearch (e) {
    if (this.disabled || this.readonly) return
    this.selectedItemByArrows = this.selectedItem = this.arrowsIndex = null
    this.setSearchData(e.target.value)
    this.$emit('search', this.getSearchData())
  },
  onScroll (event) {
    this.$emit('scroll', event)

    if (this.scrollItemsLimitCurrent >= this.itemsComputed.length) return

    const content = event.target
    const showMoreItems = (
      content.scrollHeight -
      (content.scrollTop + content.clientHeight)
    ) < 200

    if (showMoreItems) {
      this.scrollItemsLimitCurrent += this.scrollItemsLimitAddAfterScroll
    }
  }
}
